import { useState } from "react";
import useTitle from "../../hooks/useTitle";
import { useForgetPasswordMutation } from "./ForgotApiSlice";
import { useNavigate } from "react-router-dom";
import Spinner from "./Spinner";
import { FaUserAlt } from "react-icons/fa"; // Import the FaUserAlt icon

export default function ForgotPage() {
  useTitle("Vizta");
  const [username, setUsername] = useState("");
  const navigate = useNavigate();
  const [forgetPassword, { isLoading, isError, error, isSuccess }] =
    useForgetPasswordMutation();
  const handleUserInput = (e) => setUsername(e.target.value);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await forgetPassword({ username });
    } catch (err) {
      console.error("Failed to send password reset link:", err);
    }
  };
  // Handle navigation upon successful password reset request
  if (isSuccess) {
    navigate("/setPassword");
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen py-4 bg-gray-100">
      {isLoading && <Spinner />}
      <main className="w-full max-w-4xl flex flex-col lg:flex-row bg-white shadow-md rounded-lg overflow-hidden">
        {/* left-side */}
        <section className="flex flex-col justify-evenly items-center lg:w-1/2 p-4">
          {isError ? (
            <div className="text-red-600 text-xl font-medium w-full text-center bg-red-200 border border-red-600 rounded-lg flex items-center justify-center py-2 mb-4">
              {error?.data?.message || "Please enter the right email id"}
            </div>
          ) : (
            <img src="/assets/viz.png" alt="" className="w-1/2 mb-4" />
          )}
          <form
            onSubmit={handleSubmit}
            className="w-full flex flex-col gap-4 items-center"
          >
            <div className="text-2xl font-medium text-blue-950 w-full text-center mb-2">
              <h1>Forgot Password</h1>
              <p className="text-lg font-normal">
                Enter Your Email ID to Recover Your Account
              </p>
            </div>
            <div className="w-full flex flex-col gap-4 relative">
              <label
                htmlFor="username"
                className="text-lg font-medium w-full text-left"
              >
                Email:
              </label>
              <div className="relative">
                <FaUserAlt className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-400" />
                <input
                  onChange={handleUserInput}
                  id="username"
                  className="text-lg rounded border border-gray-300 px-4 py-2 pl-10 w-full"
                  value={username}
                  placeholder="enter your emailID or username"
                  required
                />
              </div>
            </div>
            <div className="flex items-center justify-between w-full mt-4">
              <button
                className="w-40 text-lg tracking-wide font-normal h-12 border bg-gray-200 rounded"
                type="button"
                onClick={() => navigate("/login")}
              >
                Cancel
              </button>
              <button
                className="w-40 rounded text-lg tracking-wide font-normal h-12 border bg-blue-950 text-white"
                type="submit"
                disabled={isLoading}
              >
                Continue
              </button>
            </div>
          </form>
        </section>
        <div className="bg-gray-300 border relative top-0 lg:left-[0.7rem] md:h-[2px] w-[90%] md:w-[2px] lg:h-[75vh]"></div>
        {/* right-side */}
        <section className="lg:w-1/2 flex flex-col items-center justify-center bg-gray-200 p-4">
          <h2 className="text-2xl lg:text-3xl text-center mb-4">
            Data Visualized, Decisions Amplified
          </h2>
          <img
            src="/assets/Data-report.png"
            alt="dataReport"
            className="w-3/4 mb-4"
          />
          <p className="text-lg font-medium text-center px-4">
            Decisions thrive when rooted in data. Harness the power of insights
            to drive informed choices and unlock unparalleled success.
          </p>
          <div className="mt-4">
            <img src="/assets/logo.png" alt="" className="w-32" />
          </div>
        </section>
      </main>
    </div>
  );
}